import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { User } from '../_models/user';
import { CustomerService } from '../_services/customer.service';
import { PricelistService } from '../_services/pricelist.service';

@Component({
    selector: 'app-nav',
    templateUrl: './nav.component.html',
    styleUrls: ['./nav.component.css'],
    standalone: false
})
export class NavComponent implements OnInit {

  model: any = {}
  hasPromotion!: boolean;
  errorMessage!: string;
  images = [
    {path: '../../../assets/opel.png'},
    {path: '../../../assets/peugeot.png'},
    {path: '../../../assets/mercedes.png'},
    {path: '../../../assets/renault.png'},
    {path: '../../../assets/ford.png'},
    {path: '../../../assets/audi.png'},
    {path: '../../../assets/volvo.png'},
    {path: '../../../assets/bmw.png'},
    {path: '../../../assets/vw.png'},
    {path: '../../../assets/toyota.png'},
    {path: '../../../assets/jaguar.png'},
    {path: '../../../assets/landrover.png'},
    {path: '../../../assets/mazda.png'},
    {path: '../../../assets/kia.png'},
    {path: '../../../assets/nissan.png'},
    {path: '../../../assets/lexus.png'},
    {path: '../../../assets/stellantis.png'},
    {path: '../../../assets/suzuki.png'},
    {path: '../../../assets/mini.png'},
    {path: '../../../assets/hyundai.png'},
    {path: '../../../assets/porsche.png'},
    {path: '../../../assets/vw-bedrijfswagens.png'},
    {path: '../../../assets/skoda.png'},
    {path: '../../../assets/psa.png'},
    {path: '../../../assets/ds.png'},
    {path: '../../../assets/citroen.png'},
    {path: '../../../assets/dacia.png'},
    {path: '../../../assets/fiat.png'},
    {path: '../../../assets/chrysler.png'},
    {path: '../../../assets/alfaromeo.png'},
    {path: '../../../assets/mitsubishi.png'},
    {path: '../../../assets/bentley.png'},
    {path: '../../../assets/maserati.png'},
    {path: '../../../assets/iveco.png'},
    {path: '../../../assets/fordpro.png'},
    {path: '../../../assets/astonmartin.png'},
    {path: '../../../assets/polestar.png'},
    {path: '../../../assets/seat.png'},
    {path: '../../../assets/eurorepar.png'},
    {path: '../../../assets/fca.png'},
    {path: '../../../assets/mopar.png'},
    {path: '../../../assets/borgwarner.png'},
    {path: '../../../assets/schrader.png'},
    {path: '../../../assets/turbo-teclogo.png'},
    {path: '../../../assets/byd.png'},
    {path: '../../../assets/mg.png'},
    {path: '../../../assets/tesla.png'},
    {path: '../../../assets/tws.png'},
    {path: '../../../assets/bogap-full.png'},
    {path: '../../../assets/chitao-full.png'},
    {path: '../../../assets/aravolt-full.png'},
    {path: '../../../assets/lynk&co.png'},
  ]

  constructor(public customerService: CustomerService, private router: Router, private pricelistService: PricelistService) {    
  }

  ngOnInit(): void {
    //this.customerService.isLoggedIn$.subscribe(loggedin => console.log("subscriber logged in " + loggedin));
    this.customerService.isTokenExpired();
    this.customerService.isLoggedIn$.subscribe(loggedin => 
    {  
      if (loggedin)
      {
        this.pricelistService.hasPromotions().subscribe({
          next: hasPromotionResult => {
            this.hasPromotion = hasPromotionResult;
          },
          error: err => this.errorMessage = err
        });
      }
    });
    
  }

  logout()
  {
    this.customerService.logout();
    this.router.navigateByUrl('/');
  }

  isPricelistRoute() {
    return this.router.url === '/pricelist';
  }

}
